import { useEffect, useState } from "react";
import useWorkOrderStats from "../../data/useWorkOrderStats";

export default function WorkOrderStats() {
  const workOrderStats = useWorkOrderStats();

  const [total     , setTotal     ] = useState(0);
  const [toDo      , setToDo      ] = useState(0);
  const [inProgress, setInProgress] = useState(0);
  const [completed , setCompleted ] = useState(0);
  const [gps       , setGps       ] = useState(0);

  useEffect(() => {
    if (workOrderStats.data?.data) {
      const data = workOrderStats.data.data;
      setTotal(data.total);
      setToDo(data.toDo);
      setInProgress(data.inProgress);
      setCompleted(data.complete);
      // GPS work orders aren't in the API response yet — derive a
      // best-effort count from whichever field the backend eventually
      // provides (gps / gpsTotal / gpsCount) so the tile lights up as
      // soon as the endpoint starts returning it.
      const anyData = data as unknown as {
        gps?: number;
        gpsTotal?: number;
        gpsCount?: number;
      };
      setGps(anyData.gps ?? anyData.gpsTotal ?? anyData.gpsCount ?? 0);
    }
  }, [workOrderStats.data]);


  return (
    <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
      <StatCard title="Total" value={total} />
      <StatCard title="To Do" value={toDo} />
      <StatCard title="In Progress" value={inProgress} />
      <StatCard title="Completed" value={completed} />
      <StatCard title="GPS Work Orders" value={gps} />
    </div>
  );
}

interface StatCardProps {
  title: string;
  value: number;
}

function StatCard({ title, value }: StatCardProps) {
  return (
    <div className="bg-white shadow rounded-lg px-4 py-3">
      <p className="text-xs font-medium text-gray-500">{title}</p>
      <p className="mt-1 text-2xl font-semibold text-gray-900">{value}</p>
    </div>
  );
}
